import { combineReducers } from 'redux'
import advancedSearchFiltersReducer from './advancedSearchFiltersReducer'
import advancedSearchResultsReducer from './advancedSearchResultsReducer'

export default combineReducers({
    advancedSearchFiltersData: advancedSearchFiltersReducer,
    advancedSearchResultsData: advancedSearchResultsReducer
})